import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import Img from '../widgets/Img';
import EbookForm from '../widgets/EbookForm';
import img1 from './page-imgs/MockUp_4.png';
import img2 from './page-imgs/Anishmind12.png'

const About = () => {
    return (
        <Fragment>
            <div className="container">
                <div className="row center-xs">
                    <div className="col-lg">
                        <div style={{marginBottom: '1rem'}} className='align-text-left'>
                            <h1><span className="text-danger">Shift</span>Mindset</h1>
                            <p className="text-nc">9 Fundamentals to Personally Transform Your Life & Business</p>
                            <p>Don’t miss out on contributing to your personal transformation through the fundamentals discovered in this book. Stop Complaining and Start Changing with the 9 Important fundamentals to personal transformation.</p>
                            <Link style={{marginTop: '1rem', display: 'block'}} className="btn btn-danger" to='/book'>Pre-Order Now</Link>
                        </div>
                    </div>
                    <div className="col-lg">
                        <img style={{width: '100%'}} src={img1} alt=""/>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="sub-text center-hori">
                    <p>Before developing your business, your relationships, your career, or any aspect of your life, the most important area you need to develop is your mindset. Your habits, decision making ability, priorities, influence, belief systems are all important concepts to understand to being the process of personal transformation. Most people have a hard time understanding why they’re in the same position they’ve always been but forget that changing your mindset is going to be a direct contributing factor changing your life & business.</p>
                </div>

                <div className="center-xs">
                    <h2 style={{marginBottom: '1rem'}}>What you'll discover:</h2>
                    <div className="row">
                        <div className="col-lg">
                            <ul style={{fontSize: '1.2em'}} className="bold">
                                <li>Chapter 1: Understanding Your Mind</li>
                                <li>Chapter 2: Prioritizing Potential</li>
                                <li>Chapter 3: Understanding Success Influence</li>
                                <li>Chapter 4: Vision Creation & Development</li>
                                <li>Chapter 5: Decision Making</li>
                            </ul>
                        </div>
                        <div className="col-lg">
                        <ul style={{fontSize: '1.2em'}} className="bold" >
                                <li >Chapter 6: Habit Development</li>
                                <li>Chapter 7: Environmental Creation</li>
                                <li>Chapter 8: Emotional Mastery</li>
                                <li>Chapter 9: Understanding Power Energies</li>
                                <li>Chapter 10: Creating Your Reality from Within</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-secondary">
                <div className="container">
                    <div className="text text-light">
                        <p>This book helps entrepreneurs who want more success in developing their lives and business by applying the 9 important fundamentals to their lives without having to be confused as to why they feel they’re experiencing failure in their life or business.</p>
                    </div>
                </div>
            </div>

            <div className="center-sm">
                <div className="container">
                    <div className="row">
                        <div className="col-lg">
                            <Img url={img2} />
                        </div>
                        <div className="col-lg">
                            <p className="text">
                                “Shift Mindset doesn’t just tell you what to change, but also why to change and most importantly how to change, that’s what makes this book so special, taking the perspective of no BS attitude to help you in your efforts to change.”
                            </p>
                            <p className='align-text-right'>- Anish Verma, Author of Shift Mindset</p>
                        </div>
                    </div>
                </div>
            </div>

            <div style={{marginBottom: '1rem'}} className="container">
                <EbookForm />
            </div>

            <div className="jumbotron bg-danger">
                <div className="container">
                    <div className="text-light">
                        <h1 style={{fontWeight: '300'}}>Emaginetalks Publishing</h1>
                        <p className="lead">Get your business book completely published by Emaginetalks With a couple of different options of learning how to Self-Publish or getting your book represented through one of Emaginetalks Publishing Plans that could get your book not only published but printed in 90 Days Time… Guaranteed!</p>
                    </div>
                </div>
            </div>

            <div className="container">
                <p style={{fontSize: '1.2em', marginBottom: '1rem'}} className="bold">Do you have a book idea but don’t know how to execute it? Do you want to write a book but have no system or publishing opportunity to effectively launch it?</p>

                <p style={{fontSize: '1.2em', marginBottom: '1rem'}}>Now you have the opportunity to get yourself represented with your very own book. Imagine being an Author, imagine the amount of recognition, the authority figure-ship you could build in your industry and the amount of clients you could attract in your business if you had your very own written book. If you’re a real estate agent, mortgage specialist, network marketer, consultant in any industry, you could literally change your career and start elevating your revenue through just writing a book. This is your opportunity to publish your own book.</p>

                <p style={{fontSize: '1.2em', marginBottom: '1rem'}}>Writing your own book could develop many opportunities in your life, such as, speaking engagements, trainings, selling products or services, and much more. The opportunities are endless with you becoming an author.</p>

                <p style={{fontSize: '1.2em', marginBottom: '1rem'}}>Emaginetalks Publishing provides you the opportunity to work with us hand-in-hand to the writing process and promotion process of your book. We will help you from start to finish in the development of your book. We’ll help you, create your cover and back cover, create the media-kit of your book to send to different news agencies for more promotional opportunity, create the advertising-kit to assist in the funding of your book to get advertisements, create a list of businesses you could target to get advertisements in your book, providing you with the resources of targeting for your book, create a powerful landing page for your book with full features of sign up and list building opportunity, creating the pre-order form strip of your book and much more, make sure you check out Emaginetalks Publishing Package to see your opportunity.</p>

                <div className="center-hori">
                    <Link className='btn btn-danger btn-lg' to='/contact'>Get Published Now</Link>
                </div>
            </div>
            

        </Fragment>
    )
}

export default About
